












import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import BgTheme1 from '@/components/bg-theme-1.vue';
import PaymentMenuComponent from '@/components/payment/payment-menu.vue';


@Component({
  components: {
    BgTheme1,
    PaymentMenuComponent
  }
})
export default class PaymentComponent extends Vue {

  mounted() {
  }
}


